import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import {
  LaminateChoices,
  TemporaryMaterialChoices,
} from 'src/app/model/product/windowsticker/windowsticker';
import Material from '../../../../model/material/material';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import ProductSize from 'src/app/model/product/product-size';
import WindowstickerMaterialAware from 'src/app/model/product/windowsticker/windowsticker-material-aware';

@Component({
  selector: 'windowsticker-material-picker',
  templateUrl: './windowsticker-material-picker.component.html',
  styleUrls: ['./windowsticker-material-picker.component.scss'],
})
export class WindowstickerMaterialPickerComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  windowMaterialForm: UntypedFormGroup;
  public foilChoices: Material[] = [];
  public laminateChoices: Material[] = [];
  public laminateDisabled: boolean = false;
  public display: boolean = false;
  @Input()
  public inputMaterialAware: WindowstickerMaterialAware;
  @Input()
  public updateEmitter: EventEmitter<any>;
  @Input()
  public productMaterialChanged: EventEmitter<any>;
  @Input()
  public temporaryMaterialChanged: EventEmitter<any>;
  @Input()
  public sizesEndpoint: string;
  @Input()
  public allProductSizes: ProductSize[];
  @Input()
  public client = false;
  @Input()
  public disabled = false;

  constructor(private formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit() {
    this.filterLaminateChoices();
    this.filterFoilChoices();
    this.laminateDisabled =
      this.checkFoilTrueVision() &&
      this.inputMaterialAware.laminate != null &&
      this.inputMaterialAware.laminate.ordinal ===
        LaminateChoices.NO_LAMINATE.ordinal;
    if (this.allProductSizes == null) {
      this.display = true;
    }
    if (this.temporaryMaterialChanged != null) {
      this.addSubscription(this.temporaryMaterialChanged, () => {
        this.filterFoilChoices();
        this.filterLaminateChoices();
      });
    }
  }

  initWindowMaterialGroup() {
    return this.formBuilder.group({
      foil: new UntypedFormControl('', Validators.required),
      laminate: new UntypedFormControl('', Validators.required),
    });
  }

  filterLaminateChoices() {
    this.laminateChoices = this.inputMaterialAware.temporaryMaterial
      ? TemporaryMaterialChoices.TEMPORARY.laminateChoices
      : TemporaryMaterialChoices.PERMANENT.laminateChoices;
  }

  filterFoilChoices() {
    this.foilChoices = this.inputMaterialAware.temporaryMaterial
      ? TemporaryMaterialChoices.TEMPORARY.foilChoices
      : TemporaryMaterialChoices.PERMANENT.foilChoices;
  }

  foilChange(event) {
    if (this.productMaterialChanged != null) {
      this.productMaterialChanged.emit();
    }
    if (this.checkFoilTrueVision()) {
      this.inputMaterialAware.laminate = LaminateChoices.NO_LAMINATE;
      this.laminateDisabled = true;
    } else {
      this.laminateDisabled = false;
    }
    this.filterLaminateChoices();
    this.updateEmitter.emit();
  }

  laminateChange(event) {
    if (
      this.inputMaterialAware.laminate === LaminateChoices.NO_LAMINATE &&
      this.checkFoilTrueVision()
    ) {
      this.laminateDisabled = true;
    }
    this.updateEmitter.emit();
  }

  checkFoilTrueVision(): boolean {
    // Laminate is fixed if foil is True Vision
    return (
      this.inputMaterialAware.foil != null &&
      (this.inputMaterialAware.foil.ordinal === 2 ||
        this.inputMaterialAware.foil.ordinal === 6)
    );
  }

  compareMaterials(o1, o2): boolean {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      if (o1.ordinal === o2.ordinal) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
